import {
    CREDIT_CARD_PATH,
    VANITY_FAIR_CARD_PATH,
    EL_HORMIGUERO_CARD_PATH,
    CREDIT_CARD_LIGHT_PATH,
    VANITY_FAIR_CARD_LIGHT_PATH,
    EL_HORMIGUERO_CARD_LIGHT_PATH,
} from '../pathInvestments';

export const BASIC = 'basic';
export const VF = 'vf';
export const EH = 'eh';

export const CREDIT_CARD_PARTNERS = {
    [CREDIT_CARD_PATH]: 'basic',
    [CREDIT_CARD_LIGHT_PATH]: 'basic',
    [VANITY_FAIR_CARD_PATH]: 'vf',
    [VANITY_FAIR_CARD_LIGHT_PATH]: 'vf',
    [EL_HORMIGUERO_CARD_PATH]: 'eh',
    [EL_HORMIGUERO_CARD_LIGHT_PATH]: 'eh',
};

const pdfByPartner = {
    [EH]: 'https://www.openbank.es/assets/static/pdf/Productos/500_804_1_EHcard/Datos_Tarjeta_El_Hormiguero.pdf',
    [VF]: 'https://www.openbank.es/assets/static/pdf/Productos/500_805_1_Tarjeta_Club_Lectura/Datos_Tarjeta_Club_lectura_Openbank_by_Vanity_Fair.pdf',
    [BASIC]: 'https://www.openbank.es/assets/static/pdf/Productos/500_802_01_Tarjeta_Viajera/Datos_Tarjeta_Viajera.pdf',
};

export const getPdfByPartnerId = partnerId => pdfByPartner[partnerId];
